import { MainBsiManager } from '@wix/bsi-manager';
import { getCommonConfig } from './common-config';
import { getConsentPolicy } from './consent-policy';
import { generateGuid } from './guid';
import { getCookieDomain } from './cookie';

export const bsiManager = MainBsiManager.create(
  {
    generateGuid,
    getCommonConfig,
    getConsentPolicy,
  },
  { cookieDomain: getCookieDomain() },
);
